export default {
  catalog: () => import("C:/BuildAgent/work/7992c122409a32d2/code/fe-app/layouts/catalog.vue").then(m => m.default || m),
  magazine: () => import("C:/BuildAgent/work/7992c122409a32d2/code/fe-app/layouts/magazine.vue").then(m => m.default || m),
  order: () => import("C:/BuildAgent/work/7992c122409a32d2/code/fe-app/layouts/order.vue").then(m => m.default || m)
}